import { MutableRefObject, useEffect, useRef } from 'react';

import { a11yFocus } from '../../../../util';

export const useFocus = <T extends HTMLElement>(isFocus: boolean): MutableRefObject<T | undefined> => {
  const ref = useRef<T>();

  useEffect(() => {
    if (isFocus) {
      a11yFocus(ref.current);
    }
  }, [isFocus]);

  return ref;
};
